import * as $ from "jquery";
import * as powerbi from 'powerbi-client';

$(function () {
  if (!window.powerbiAccessToken){
    return; // No powerBi in use on this page
  }
  
  const powerbiService = new powerbi.service.Service(powerbi.factories.hpmFactory, powerbi.factories.wpmpFactory, powerbi.factories.routerFactory);
  powerbiService.accessToken = window.powerbiAccessToken;
  
  $('[data-embedurl]').each((_, element) => {
    let $reportContainer = $(element);
    let embedConfiguration: powerbi.IEmbedConfiguration = {
      type: 'tile',
      tokenType: powerbi.models.TokenType.Aad,
      //accessToken: => zetten we globaal zie boven
      embedUrl: $reportContainer.data('embedurl'),
      dashboardId: $reportContainer.data('dashboardid'),
      id: $reportContainer.data('tileid')
    };

    let report = powerbiService.embed(element, embedConfiguration) as powerbi.Report;

    report.on('loaded', async function () {
      console.log('Report loaded successfully!');

      // Get the active page
      const pages = await report.getPages();
      const activePage = pages[0];

      if (activePage) {
        console.log(`Active page: ${activePage.displayName}`);

        // Get all visuals on the active page
        const visuals = await activePage.getVisuals();

        // Log the visuals
        visuals.forEach(visual => {
          console.log(`Visual Name: ${visual.name}, Visual Type: ${visual.type}`);
        });
      } else {
        console.error('Page not found');
      }
    });

    report.on('error', function (event) {
      console.error(event.detail);
    });
  });
});
